import React, { useEffect, useState } from "react";
import { authorizedGet } from "../../Config/networkWithToken";
import configuration from "../../Config/configuration";
import { Link } from "react-router-dom";

import {
  config,
  DOBASEURL,
  getValueFromLocalStorage,
  localStorageKey,
} from "../../utils/helper";
import Spinner from "../../Components/Spinner/Spinner";
import Images from "../../utils/images";
import { ImCancelCircle } from "react-icons/im";
import { IoIosSearch } from "react-icons/io";
import AdvanceSearch from "../../Components/AdvanceSearch/AdvanceSearch";

const BlockedUsers = () => {
  const [blockedUsers, setBlockedUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const adminId = getValueFromLocalStorage(localStorageKey.USERDATA, "adminId");
 const [searchQuery, setSearchQuery] = useState("");
  const [showAdvanceSearch, setShowAdvanceSearch] = useState(false);  const [filter, setFilter] = useState("all");
  const fetchBlockedUser = async () => {
    setLoading(true);
    try {
      const res = await authorizedGet(
        `${configuration.apis.getBlockedUsers}?adminId=${adminId}`,
        config,
      );
      const responseStatus = res?.data;
      if (responseStatus?.status) {
        const response = responseStatus?.data;
        console.log("Response", response);
        setBlockedUsers(response);
      }
    } catch (err) {
      console.log("Error fetching data:", err);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchBlockedUser();
  }, [adminId]);
  //  For seemore and seeless
  // const [expanded, setExpanded] = useState({});

  // const toggleExpand = (id) => {
  //   setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
  // };
 const handleAdvanceSearch = (searchValue) => {
    setSearchQuery(searchValue.toLowerCase());
  };

  const toggleSearchBar = () => {
    setShowAdvanceSearch((prev) => !prev);
    setSearchQuery("");
  };
  const filterBlockedUser = () => {
    const today = new Date();

    return blockedUsers?.filter((user) => {
      const blockedAt = user.blockedAt ? new Date(user.blockedAt) : null;

      if (!blockedAt || isNaN(blockedAt)) return false;

      const diffTime = Math.abs(today.getTime() - blockedAt.getTime());
      const diffDays = diffTime / (1000 * 60 * 60 * 24);

      if (filter === "today")
        return blockedAt.toDateString() === today.toDateString();
      if (filter === "week") return diffDays < 7 && diffDays >= 0;
      if (filter === "month")
        return (
          blockedAt.getMonth() === today.getMonth() &&
          blockedAt.getFullYear() === today.getFullYear()
        );
      if (filter === "year")
        return blockedAt.getFullYear() === today.getFullYear();

      return true;
    });
  };

  const filteredBlockedUser = filterBlockedUser().filter((user) =>
    user.name.toLowerCase().includes(searchQuery),
  );
  return (
    <div className="p-4">
      <div className="mb-4 flex flex-wrap items-center justify-center gap-4">
        <div className="flex w-full items-center justify-center text-xs text-gray-400 md:justify-end">
          Note: The details are sorted by the date the user was blocked.
        </div>
        <h2 className="text-lg text-gray-800 sm:text-xl md:text-2xl lg:text-3xl">
          Blocked Users{" "}
          <span className="text-[20px] font-normal text-gray-500">
            ({filteredBlockedUser.length})
          </span>
        </h2>

        {/* Search and Sort */}
        <div className="ml-auto flex flex-wrap items-center gap-2 sm:gap-4">
          {/* Search Icon & Advanced Search */}
          <div className="flex items-center rounded-lg px-2 py-1">
            {!showAdvanceSearch ? (
              <IoIosSearch
                className="cursor-pointer text-xl text-gray-500 sm:text-2xl"
                onClick={toggleSearchBar}
              />
            ) : (
              <div className="flex items-center gap-2">
                <AdvanceSearch onSearchValue={handleAdvanceSearch} />
                <ImCancelCircle
                  className="cursor-pointer text-lg text-gray-500 sm:text-xl"
                  onClick={toggleSearchBar}
                />
              </div>
            )}
          </div>

          {/* Sort Dropdown */}
          <p>Sort by:</p>
          <select
            className="rounded-md border px-2 py-1 text-sm sm:text-base"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          >
            <option value="all">All</option>
            <option value="today">Today</option>
            <option value="week">This Week</option>
            <option value="month">This Month</option>
            <option value="year">This Year</option>
          </select>
        </div>
      </div>

      <div className="mb-4 flex space-x-4 border-b border-gray-300"></div>

      <div className="flex flex-wrap justify-start gap-5">
        {" "}
        {loading ? (
          <div className="col-span-3 flex min-h-screen items-center justify-center">
            <Spinner />
          </div>
        ) : filteredBlockedUser.length > 0 ? (
          filteredBlockedUser?.map((user) => (
            <div
              key={user.id}
              className="flex w-full flex-col items-center gap-3 rounded-lg bg-white p-3 shadow-md xxs:w-[80%] sm:w-[65%] sm:flex-row md:h-[220px] md:w-[45%]"
            >
              {/* Circular Profile Image */}
              <div className="flex w-full flex-col items-center justify-center  gap-2 md:w-[25%]">
                <img
                  src={
                    user?.photos?.length > 0
                      ? DOBASEURL + user?.photos?.[0]
                      : user?.gender === "male"
                        ? Images.MEN
                        : Images.WOMEN
                  }
                  alt={user.name}
                  className="h-20 w-20 rounded-full border border-gray-300 object-cover"
                />
                <div className="text-center">
                  <p className="text-base font-medium">
                    {" "}
                    {user.name.length > 10
                      ? `${user.name.slice(0, 10)}...`
                      : user.name}
                  </p>
                </div>
              </div>
              <div className="flex w-full flex-col items-center justify-center gap-2 md:w-[65%]">
                {/* User Info */}

                <div className="flex w-full flex-col items-start justify-center px-2 text-left">
                  <p className="whitespace-normal break-words text-sm font-semibold text-gray-800">
                    Email:{" "}
                    <span className="font-normal">{user.primaryEmail}</span>
                  </p>
                  <p className="text-sm font-semibold text-gray-800">
                    Phone No: <span className="font-normal">{user.phone}</span>
                  </p>
                  <p className="text-sm font-semibold text-gray-800">
                    Blocked Date:{" "}
                    <span className="font-normal">
                      {user.blockedAt
                        ? new Date(user.blockedAt).toLocaleDateString("en-GB")
                        : "N/A"}
                    </span>
                  </p>

                  <p className="text-sm font-semibold text-gray-800">
                    Blocked By:{" "}
                    <span className="font-normal">{user.admin}</span>
                  </p>

                  {/* Truncated Reason with See More */}
                  {/* <p className="text-sm font-semibold text-gray-800">
              Reason:
              <span className="font-normal">
                {expanded[user.id]
                  ? ` ${user.reason}`
                  : ` ${user.reason.slice(0, 60)}... `}
              </span>
              {!expanded[user.id] && user.reason.length > 60 && (
                <button
                  onClick={() => toggleExpand(user.id)}
                  className="text-sm text-blue-500"
                >
                  See More
                </button>
              )}
              {expanded[user.id] && (
                <button
                  onClick={() => toggleExpand(user.id)}
                  className="text-sm text-red-500"
                >
                  See Less
                </button>
              )}
            </p> */}
                  <p className="text-sm font-semibold text-gray-800">
                    Reason:
                    <span className="max-h-[4.5rem] overflow-y-auto font-normal [-webkit-box-orient:vertical] [-webkit-line-clamp:2] [display:-webkit-box]">
                      {user.reason}
                    </span>
                  </p>
                </div>
                {/* Buttons */}
                <div className="flex w-full items-center justify-center">
                  <Link
                    to={`/blocked-users/viewProfile/${user._id || user?.userId}`}
                    className="w-full"
                  >
                    <button className="w-full flex-1  rounded bg-textYellow px-4 py-1 text-white  hover:bg-amber-400">
                      View Profile
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-span-3 flex w-full items-center justify-center">
            <p className="text-center text-xl text-gray-500">
              No blocked users found.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default BlockedUsers;
